import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { deleteEmployerCountry } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useDeleteEmployerCountryQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.DeleteEmployerCountry], deleteEmployerCountry, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerDashboard])
        toast.success(AppNotification.DeleteEmployerCountrySuccess)
      } else {
        toast.error(`${AppNotification.DeleteEmployerCountryFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.DeleteEmployerCountryFailure)
    }
  })
}
